import { Fragment, useEffect, useState } from "react"
import { useSelector } from "react-redux"

export default function Backdrop(props) {

    let showBackdrop = useSelector((state) => state.backdrop.show)

    const [mountBackdrop, setMountBackdrop] = useState(showBackdrop)

    useEffect(() => {
        setMountBackdrop(showBackdrop)
    }, [showBackdrop])


    if (!mountBackdrop) {
        return <Fragment></Fragment>
    }

    return <div className='backdrop react' ></div>

}



  


  